module.exports = __webpack_public_path__ + "img/ban3.69c40169.jpg";